import { QueryKey, useQueryClient } from '@tanstack/react-query'

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient()
  const invalidateQueries = (keys: QueryKey) => {
    keys.forEach((queryKey) => {
      queryClient.invalidateQueries({
        queryKey: [queryKey]
      })
    })
  }

  return {
    invalidateQueries
  }
}
